export const formData = [{
    key: 'seller_name',
    type: 'text',
    value: '',
    valid: false,
    
    elementConfig: {
        name: 'seller_name',
        label: 'name',
        placeholder: 'Seller Name Pvt Ltd'
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation:{
        required:"",
        message: ""
    }

}, {
    key: 'seller_code',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'seller_code',
        label: 'code',
        placeholder: 'SEL'
    },
    validation: {
        required: true,
        message: "is required"

    },
    fieldValidation:{
        required:"",
        message: ""
    }
}, {
    key: 'address',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'address',
        label: 'Address',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation:{
        required:"",
        message: ""
    }
}, {
    key: 'city',
    type: 'text',
    value: '',
    valid: true,
    fieldValid:true,
    elementConfig: {
        name: 'city',
        label: 'City',
        placeholder: ''
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
        message: "is invalid"
    }
}, {
    key: 'pincode',
    type: 'text',
    value: '',
    valid: false,
    fieldValid: true,
    elementConfig: {
        name: 'pincode',
        label: 'Pincode',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation: {
        required: "^[0-9]{6}$",
        message: "should be 6 digits"
    }
}, {
    key: 'state',
    type: 'text',
    value: '',
    valid: true,
    fieldValid:true,
    elementConfig: {
        name: 'state',
        label: 'State',
        placeholder: ''
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
        message: "is invalid"
    }
}, {
    key: 'country',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'country_name',
        label: 'Country',
        options: []
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"",
        message: ""
    }
},
{
    key: 'is_white_labeled_solution',
    type: 'checkbox',
    value: '',
    valid: true,
    elementConfig: {
        name: 'is_white_labeled_solution',
        label: 'Is white labeled solution',
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"",
        message: ""
    }
}
]

export const addSellerAdmin = [{
    key: 'full_name',
    type: 'text',
    value: '',
    valid: false,
    fieldValid:true,
    // regex: "^[a-zA-Z]*[a-zA-Z ]+$",
    elementConfig: {
        name: 'Name',
        label: 'Full Name',
        placeholder: 'Your Name'
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation:{
        required:"^[a-zA-Z]*[a-zA-Z ]+$",
        message: "is invalid"
    }

}, {
    key: 'short_name',
    type: 'text',
    value: '',
    valid: false,
    fieldValid:true,

    elementConfig: {
        name: 'Short_name',
        label: 'Short Name',
        placeholder: 'Your Short name'
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation:{
        required:"^[a-zA-Z]*[a-zA-Z ]+$",
        message: "is invalid"
    }
}, 
{
    key: 'email',
    type: 'email',
    value: '',
    valid: false,
    fieldValid:true,
    elementConfig: {
        name: 'email',
        label: 'Email',
        placeholder: 'Enter email'
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation:{
        required: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: 'is invalid'
    }
},
{
    key: 'seller_id',
    type: 'hidden',
    value: '',
    valid: true,
    fieldValid:true,
    elementConfig: {
        name: 'seller_id',
        label: '',
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"",
        message: ""
    }
}]


export const sellCredits = [
    {
        key: 'seller_id',
        type: 'hidden',
        value: '',
        valid: true,
        elementConfig: {
            name: 'seller_id',
            label: '',
        },
        validation: {
            required: false,
            message: ""
        },
        fieldValidation:{
            required:"",
            message: ""
        }
    }, {
        key: 'credits',
        type: 'number',
        value: '',
        valid: false,
        fieldValid:true,
        elementConfig: {
            name: 'credits',
            label: 'No of Credits',
            placeholder: '999'
        },
        validation: {
            required: true,
            message: "is required"
        },
        fieldValidation:{
            required:"^[1-9]*$",
            message: "is invalid"
        }
    },
    {
        key: 'instrument_id',
        type: 'hidden',
        value: '',
        valid: true,
        elementConfig: {
            name: 'instrument_id',
            label: '',
        },
        validation: {
            required: false,
            message: ""
        },
        fieldValidation:{
            required:"",
            message: ""
        }
    }]


export const revokeCredits = [{
    key: 'seller_id',
    type: 'hidden',
    value: '',
    valid: true,
    elementConfig: {
        name: 'seller_id',
        label: '',
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"",
        message: ""
    }
}, {
    key: 'credits',
    type: 'number',
    value: '',
    valid: false,
    fieldValid:true,
    elementConfig: {
        name: 'credits',
        label: 'No of Credits',
        placeholder: '999'
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation:{
        required:"^[1-9]*$",
        message: "is invalid"
    }
},
{
    key: 'instrument_id',
    type: 'hidden',
    value: '',
    valid: true,
    maxCreditRevoked: '',
    instrumentName: '',
    elementConfig: {
        name: 'instrument_id',
        label: '',
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"",
        message: ""
    }
}]



// WEBPACK FOOTER //
// ./src/_pages/Admin/Sellers/formData.js